import { Box, Icon, VStack } from '@chakra-ui/react';
import { useWSysHub, useWSysPage, useWSysPath } from "@coimbra-its/websys-ux-core";
import React, { useEffect, useState } from 'react';
import { SunBlock, SunButton, SunLinkButton, SunPage, SunStack } from "../components/Sun";
import { SunState, useSunStore } from '../store/sunSlice';
import { ADMINS } from '../web3/config';
import { useSdbn2Api } from '../store/sdbn.api';
import { IUserPub } from '@coimbra-its/api.sdbn.wallet';
import { APPICONS } from '../Icons';


export interface DashboardProps {
    walletBox: React.ReactNode;
}


export function Dashboard({ walletBox }: DashboardProps) {
    const path = useWSysPath();
    const page = useWSysPage({ title: 'SDBN WALLET APP', maxCols: 2, onClosed: false })
    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);
    const user = useSunStore(state => state.user);
    const isAdmin = connectedWallet && ADMINS.indexOf(connectedWallet.address) >= 0;
    const hub = useWSysHub();
    const api = useSdbn2Api();

    const [sasLink, setSasLink] = useState('');

    useEffect(() => {
        if (user && user.smnetStatus === 'redirect') {
            let url = user.smnetData;
            let lang = window.localStorage.getItem('lang');
            if (lang) {
                if (url.indexOf('?') == -1)
                    url += '?lang=' + lang;
                else
                    url += '&lang=' + lang;
            }
            setSasLink(url);
        } else {
            setSasLink('');
        }
    }, [user]);

    return <SunPage page={page} >

        <SunStack>
            {walletBox}
            {/*<Box>user: {user ? JSON.stringify(user) : 'no user'}</Box>*/}
            {/*!!connectedWallet && <>
                <SunLinkButton onClick={() => path.open('wallet')}>Wallet</SunLinkButton>
            </>*/}
            {sasLink && <SunBlock>
                <Box display='flex' flexDir='column' alignItems='center' textAlign='center' py={8} >
                        This wallet is not connected with any Sunmoney Account.<br />
                        Click to create account!<br />
                    <a href={sasLink}><SunButton >Connect wallet with Sunmoney.net account</SunButton></a>
                </Box>
            </SunBlock>}
            {user && user.smnetStatus === 'ok' && <SunBlock textAlign='center' py={8}>
                Your wallet is succesfully connected to your Sunmoney.net account.
            </SunBlock>}
            {user && user.smnetStatus !== 'ok' && user.smnetStatus !== 'redirect' && <SunBlock>
                <div>{user.smnetStatus}</div>
                <div>{JSON.stringify(user.smnetData)}</div>                
            </SunBlock>}
            
        </SunStack>
    </SunPage >
}


